import Axios from 'axios'

const actions = {
  getUsers ({rootState}) {
    return new Promise(async resolve => {
      const users = await Axios.get(rootState.roots_url + '/users')
      resolve(users)
    })
  },
  getUserById ({rootState}, userId) {
    return new Promise(async resolve => {
      const { data: user } = await Axios.get(rootState.roots_url + '/users/' + userId)
      resolve(user)
    })
  },
  updateUser ({rootState}, user) {
    return new Promise(async resolve => {
      const data = await Axios.post(rootState.roots_url + '/users/' + user.id, user)
      resolve(data)
    })
  },
  createUser ({ rootState }, user) {
    return new Promise(async resolve => {
      const data = await Axios.post(rootState.roots_url + '/users', user)
      resolve(data)
    })
  }
}

export default {
  actions
}
